import { createSelector } from 'reselect';
import { errorsToTouch } from '@synergy/utils';

import { AppState } from '../../../../../../store/models/app-state';
import { ProductAttribute } from '../models/product-attribute';

const productDetailAttributeState = (state: AppState) => state.product.detail.attributes;

/**
 * The mask always shows a row, so an empty list becomes one blank one. Shared
 * with the unsaved-changes baseline (#2159) — otherwise that blank row alone
 * would read as something the user typed.
 */
const withDefaults = (attributes: ProductAttribute[] | null) => ({
    attributes: [...(attributes && attributes.length > 0 ? attributes : [{ id: null, attributeId: null, value: '' }])],
});

export const productDetailAttributeFormDataSelector = createSelector(productDetailAttributeState, attributesState => ({
    formValues: withDefaults(attributesState.attributes),
    errors: { ...attributesState.errors },
    touched: errorsToTouch(attributesState.errors),
}));

/** What the tab compares against to decide whether anything is unsaved. */
export const productDetailAttributesBaselineSelector = createSelector(productDetailAttributeState, attributesState =>
    attributesState.baseline ? withDefaults(attributesState.baseline) : undefined
);

export const productDetailAttributesRequestSelector = createSelector(productDetailAttributeState, attributesState => {
    if (!attributesState.productId || !attributesState.attributes) {
        return null;
    }

    return {
        id: attributesState.productId,
        attributes: attributesState.attributes,
    };
});
